import { gql } from 'apollo-boost';
import { s3BucketUrl } from 'config';

export const HIDOE_DATA_BOOK_SLUG = 'hidoe-data-book';

export const makeUrl = (slug: string, year: number, filename: string): string => {
  return `${s3BucketUrl}/${slug}/${year}/${filename}`;
};

export const GET_BUCKET_CONTENTS = gql`
  query getBucketContents($slug: String!, $year: Int!) {
    getBucketContents(slug: $slug, year: $year) {
      items {
        filename
      }
    }
  }
`;
